import { loadWhop } from '@whop/elements';

/** Single Whop Elements runtime — withdraw uses one consumer instance per page. */
export const whopElementsLoader = loadWhop();
